import { createFileRoute } from '@tanstack/react-router';
import { TemplateDetails, TextKey } from '@mews-commander/contracts';
import { FeatureFlag } from '@mews-commander/enums';
import { MewsTeam, RouteType } from '@mews/enums';

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Settings/ReservationContracts/Template/$id')(
    {
        beforeLoad: ({ context: { checkFeatureFlag } }) => {
            checkFeatureFlag(FeatureFlag.contractingTemplateMappingEnabled);
        },
        component: Component,
        staticData: {
            owner: MewsTeam.Spacetime,
            type: RouteType.Frontend,
            title: TextKey.ContractsTemplateDetailPageTitle,
        },
    }
);

function Component() {
    const { id } = Route.useParams();
    return <TemplateDetails templateId={id} />;
}
